import Helper from "../Helper";

/**
 * This class represents plus minus counter that recalculate price strings and data values.
 */
 export default class PriceCounter {

    /**
     * Constructor
     * @param name
     */
    constructor(name)
    {
        this.changersWrapper = $('[data-price-counter="' + name + '"]');
        this.outputsWrapper = $('[data-price-counter-ouput="' + name + '"]');
        this.countViewer = $('[data-price-counter-viewer="' + name + '"]');
        this.spanCounter = $('[data-count-entity="'+name+'"]');

        this.minCount = parseInt(this.changersWrapper.data('priceCounterMin'));
        this.maxCount = parseInt(this.changersWrapper.data('priceCounterMax'));

        this.count = this.minCount;

        this.initialiseChangers();
    }

  /**
   * This function initialises the counter changers.
   */
    initialiseChangers()
    {
        this.changersWrapper.find('[data-counter-changer]').each((index, element) => {
            element = $(element);

            // If the element has specific value to change count (+/- 1)
            if (element.data('counterChanger')) {
                element.click(() => {
                    let changeCount = parseInt(element.data('counterChanger'));
                    let newCount = this.count + changeCount;

                    this.updateCount(newCount);
                });
            } else {
                // Else elements value is supposed to be new count
                element.change(() => {
                    let newCount = parseInt(element.val());

                    this.updateCount(newCount);
                });
            }
        });
    }

  /**
   * This function will update count of the counter.
   * Also calls function to update all prices.
   *
   * @param {Number} newCount
   */
    updateCount(newCount)
    {
        if (newCount >= this.minCount && newCount <= this.maxCount) {
            this.count = newCount;
        }

        if (this.countViewer.is('input')) {
            this.countViewer.val(this.count);
        } else {
            this.countViewer.html(this.count);
        }

        this.spanCounter.html(this.count);

        this.updatePrices();
    }

  /**
   * This function will update all prices with current count.
   */
    updatePrices()
    {
        this.outputsWrapper.find('[data-price-counter-base]').each((index, element) => {
            element = $(element);
            let basePrice = parseFloat(element.data('priceCounterBase')).toFixed(2);

            element.html(Helper.formatPrice(basePrice * this.count));
        });
    }

  /**
   * This function will reset counter and all its prices.
   */
    resetCounter()
    {
        this.updateCount(this.minCount);
    }

  /**
   * Returns counter's count.
   * * Could be used in adding treatment to cart item.
   *
   * @returns {Number}
   */
    getCount()
    {
        return this.count;
    }
 }
